import { getResponseMessage } from '@app/shared/utils/response-message.util';
import {
  Component,
  Output,
  EventEmitter,
  inject,
  OnInit,
  ViewChild,
  ElementRef,
  OnDestroy,
  NgZone,
} from '@angular/core';
import { CheckboxModule } from 'primeng/checkbox';
import { CommonModule } from '@angular/common';
import { EnumService } from '@app/shared/components/api/services/enum.service';
import { ActivatedRoute } from '@angular/router';
import { RouteUtils } from '@app/core/utils/route.util';
import { CampanhaService } from '@app/shared/components/api/services/campanha.service';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { AnexoFicheiroService } from '@app/shared/components/api/services/anexo-ficheiro.service';
import { TrimTextPipe } from '@app/shared/pipes/trim-text.pipe';
import { SocialIconPipe } from '@app/shared/pipes/social-icon.pipe';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { FormsModule, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { SupenderCampanhaComponent } from '@app/shared/components/supender-campanha/supender-campanha.component';
import { ButtonModule } from 'primeng/button';
import { RejeitarCampanhaComponent } from '@app/shared/components/rejeitar-campanha/rejeitar-campanha.component';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { SkeletonLoaderComponent } from '@app/shared/components/skeleton-loader/skeleton-loader.component';
import { SafeUrlPipe } from '@app/shared/pipes/safe-url.pipe';
import { MoneyPipe } from '@app/shared/pipes/money.pipe';
import { DialogService } from 'primeng/dynamicdialog';
import { CampanhaMidiaDialogComponent } from '../campanha-midia-dialog/campanha-midia-dialog.component';
import { LoaderComponent } from '@app/shared/components/loader/loader.component';

@Component({
  selector: 'app-admin-extend-detalhe-campanha',
  imports: [
    CommonModule,
    FormsModule,
    CheckboxModule,
    BackButtonComponent,
    SocialIconPipe,
    TrimTextPipe,
    ConfirmDialogModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    SupenderCampanhaComponent,
    RejeitarCampanhaComponent,
    DataVoidComponent,
    SkeletonLoaderComponent,
    SafeUrlPipe,
    MoneyPipe,
    LoaderComponent,
  ],
  providers: [
    EnumService,
    CampanhaService,
    AnexoFicheiroService,
    DialogService,
  ],
  templateUrl: './admin-extend-detalhe-campanha.component.html',
  styleUrl: './admin-extend-detalhe-campanha.component.scss',
})
export class AdminExtendDetalheCampanhaComponent implements OnInit, OnDestroy {
  @ViewChild('nativeVideo') nativeVideo!: ElementRef<HTMLVideoElement>;
  @ViewChild('youtubePlayerIframe')
  youtubePlayerIframe!: ElementRef<HTMLIFrameElement>;

  isPlaying: boolean = false;
  currentTime: number = 0;
  duration: number = 0;
  progressPercent: number = 0;
  isOverlayVisible: boolean = false;
  volume: number = 70;
  isMuted: boolean = true;
  private overlayTimeout: any;
  private ytPlayer: any;
  private ytInterval: any;

  ngZone = inject(NgZone);

  campanha: any;
  campanhaID: any;
  ativateRouder = inject(ActivatedRoute);
  enumService = inject(EnumService);
  campanhaService = inject(CampanhaService);
  anexoFicheiroService = inject(AnexoFicheiroService);
  messageService = inject(MessageService);
  confirmationService = inject(ConfirmationService);
  dialogService = inject(DialogService);
  fb = inject(FormBuilder);
  tipoFinanciamento: any[] = [];
  @Output() onCloseModal = new EventEmitter<boolean>();
  selectedTypeFinancy: number | null = null;
  imgPreview?: string;
  docPreview?: SafeResourceUrl;
  vidPreview?: string;
  linkVideo: string = '';
  rawVideoUrl: string = '';
  embedVideoUrl?: any;
  docRawUrl?: string;
  imgRawUrl?: string;
  imgInfo?: { nome: string; tamanho: string; tipo: string };
  docInfo?: { nome: string; tamanho: string; tipo: string };
  VidInfo?: { nome: string; tamanho: string; tipo: string };
  loading: boolean = true;
  loadingRejeit: boolean = false;
  loadingSuspend: boolean = false;
  loadingMidea: boolean = false;
  showRejeitCampanha: boolean = false;
  showDialogSuspend: boolean = false;

  constructor(private readonly sanitizer: DomSanitizer) {}

  ngOnInit() {
    const encryptedId = this.ativateRouder.snapshot.paramMap.get('id');
    const id = encryptedId ? RouteUtils.decryptId(encryptedId) : null;
    this.campanhaID = id;
    this.getCampanhaByID(this.campanhaID || '');
    this.getAllTipoFinanciamento();
  }

  getCampanhaByID(id: string) {
    this.campanhaService.show(id).subscribe({
      next: (res) => {
        this.campanha = res.data;
        const fotoAnexo = this.campanha.anexoCampanha?.find(
          (a: any) => a?.tipoAnexoCampanha?.tipo === 'Imagem',
        );
        const DocAnexo = this.campanha.anexoCampanha?.find(
          (a: any) => a?.tipoAnexoCampanha?.tipo === 'Apresentação',
        );
        const videoAnexo = this.campanha.anexoCampanha?.find(
          (a: any) => a?.tipoAnexoCampanha?.tipo === 'Video',
        );

        const rawVideo = videoAnexo?.anexo?.url;
        this.rawVideoUrl = rawVideo ? this.formatExternalUrl(rawVideo) : '';
        this.linkVideo = rawVideo ? this.getEmbedUrl(rawVideo) : '';
        if (this.linkVideo) {
          this.embedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.linkVideo);
        }

        if (this.linkVideo) {
          setTimeout(() => {
            if (this.linkVideo.includes('youtube.com/embed/')) {
              this.initYoutubePlayer();
            } else if (this.linkVideo.includes('vimeo.com/')) {
              this.isPlaying = true;
            }
          }, 500);
        }

        if (DocAnexo?.anexo?.id) this.getDocsCampanha(DocAnexo.anexo.id);
        if (fotoAnexo?.anexo?.id) this.getPhotoCampanha(fotoAnexo.anexo.id);

        if (!this.linkVideo && videoAnexo?.anexo?.id) {
          this.getVideoCampanha(videoAnexo.anexo.id);
        }

        this.loading = false;
      },
      error: (err) => {
        console.error(err);
        this.loading = false;

        // Exibir mensagem de erro genérica ou recebida
        const errMessage =
          err?.error?.retorno?.mensagem ||
          err?.message ||
          'Acesso negado ou campanha indisponível.';
      },
    });
  }

  formatExternalUrl(url?: string): string {
    if (!url) return '';
    const trimmed = url.trim();
    if (!trimmed.startsWith('http://') && !trimmed.startsWith('https://')) {
      return `https://${trimmed}`;
    }
    return trimmed;
  }

  openFile(url?: string) {
    if (url) window.open(this.formatExternalUrl(url), '_blank');
  }

  getEmbedUrl(url: string): string {
    if (!url) return '';
    const formatted = this.formatExternalUrl(url);

    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const originParam = origin ? `&origin=${encodeURIComponent(origin)}` : '';

    // Videos YouTube longos
    if (formatted.includes('youtube.com/watch?v=')) {
      const id = formatted.split('v=')[1]?.split('&')[0];
      return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&enablejsapi=1${originParam}`;
    }

    // Videos YouTube curtos
    if (formatted.includes('youtu.be/')) {
      const id = formatted.split('youtu.be/')[1]?.split('?')[0];
      return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&enablejsapi=1${originParam}`;
    }

    // YouTube Shorts
    if (formatted.includes('youtube.com/shorts/')) {
      const id = formatted.split('youtube.com/shorts/')[1]?.split('?')[0];
      return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&enablejsapi=1${originParam}`;
    }

    // Videos Vimeo
    if (formatted.includes('vimeo.com/')) {
      const id = formatted.split('vimeo.com/')[1]?.split('?')[0];
      return `https://player.vimeo.com/video/${id}?autoplay=1&loop=1&muted=1&background=0&api=1`;
    }

    // Direct link (.mp4 etc.)
    return formatted;
  }

  getVideoCampanha(id: number) {
    if (!id) return;
    this.anexoFicheiroService.getAnexo(id).subscribe({
      next: (blob: Blob) => {
        const videoBlob = blob.type
          ? blob
          : new Blob([blob], { type: 'video/mp4' });

        this.vidPreview = this.sanitizer.bypassSecurityTrustResourceUrl(
          URL.createObjectURL(videoBlob),
        ) as any;

        this.VidInfo = {
          nome: `Video_${id}.mp4`,
          tamanho: `${(videoBlob.size / 1024).toFixed(2)} KB`,
          tipo: 'video/mp4',
        };
      },
      error: (err) => console.error(err),
    });
  }

  getPhotoCampanha(id: any) {
    if (!id) return;
    this.anexoFicheiroService.getAnexo(id).subscribe({
      next: (fotoRes: any) => {
        const originalBlob =
          fotoRes instanceof Blob ? fotoRes : new Blob([fotoRes]);

        const imageBlob = originalBlob.type
          ? originalBlob
          : new Blob([originalBlob], { type: 'image/jpeg' });

        const objectUrl = URL.createObjectURL(imageBlob);
        this.imgRawUrl = objectUrl;

        this.imgPreview = this.sanitizer.bypassSecurityTrustUrl(
          objectUrl,
        ) as any;

        this.imgInfo = {
          nome: `Imagem_${id}.jpg`,
          tamanho: `${(imageBlob.size / 1024).toFixed(2)} KB`,
          // tipo: imageBlob.type
          tipo: 'image/jpeg',
        };
      },
      error: (err) => console.error(err),
    });
  }

  getDocsCampanha(id: any) {
    if (!id) return;
    this.anexoFicheiroService.getAnexo(id).subscribe({
      next: (originalBlob: any) => {
        const pdfBlob = originalBlob.type
          ? originalBlob
          : new Blob([originalBlob], { type: 'application/pdf' });

        const objectUrl = URL.createObjectURL(pdfBlob);
        this.docRawUrl = objectUrl;

        this.docPreview =
          this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);

        this.docInfo = {
          nome: `Apresentação_${id}.pdf`,
          tamanho: `${(pdfBlob.size / 1024).toFixed(2)} KB`,
          tipo: pdfBlob.type,
        };
      },
      error: (err) => console.error(err),
    });
  }

  isCampanhaRecompensa(): boolean {
    return (
      Number(this.campanha?.tipoFinanciamentoENUM) === 3 ||
      String(this.campanha?.tipoFinanciamento).toLowerCase() === 'recompensa' ||
      (Array.isArray(this.campanha?.recompensa) && this.campanha.recompensa.length > 0)
    );
  }

  getSomaRecompensas(): number {
    if (!Array.isArray(this.campanha?.recompensa)) return 0;
    return this.campanha.recompensa.reduce((acc: number, r: any) => {
      const val = Number(r.valor) || 0;
      const qtd = Number(r.quantidade) || 1;
      return acc + val * qtd;
    }, 0);
  }

  getAllTipoFinanciamento() {
    this.enumService.getAllTipoFinanciamento().subscribe((result) => {
      this.tipoFinanciamento = Object.entries(result.data).map(
        ([key, value]) => ({
          id: Number(key),
          label: value,
        }),
      );
      this.setCheck();
    });
  }

  publicarCampanha() {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja publicar esta campanha?',
      header: 'Confirmação',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Sim, Publicar',
      },
      accept: () => {
        const id = this.campanhaID;
        const estado = '4';

        this.campanhaService.updateStatus(id, estado).subscribe({
          next: (res) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: getResponseMessage(res, 'Campanha publicada com sucesso!'),
              life: 5000,
            });
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: getResponseMessage(err, 'Ocorreu um erro ao publicar a campanha'),
              life: 5000,
            });
            console.error(err);
          },
        });
      },
      reject: () => {
        // Ação ao cancelar (se necessário
      },
    });
  }

  showdialogRejeit() {
    this.showRejeitCampanha = true;
  }

  // Supender campanha -- Estado 5
  suspenderCampanha(campanha: any) {
    this.showDialogSuspend = true;
    this.campanhaID = campanha.id;
  }

  setCheck() {
    if (this.campanha?.tipoFinanciamentoENUM) {
      this.selectedTypeFinancy = this.campanha?.tipoFinanciamentoENUM;
    }
  }

  cancel(): void {
    this.showRejeitCampanha = !this.showRejeitCampanha;
  }

  getPercent(campanha: any): number {
    return Math.round((campanha.valorArrecado / campanha.metaArrecadar) * 100);
  }

  showVideo = false;
  showImage = false;
  ShowDoc = false;

  abrirVideo() {
    this.showVideo = true;
  }

  abrirVideoLink(url?: string) {
    if (!url) return;
    const embed = this.getEmbedUrl(url);
    this.embedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embed);
    this.showVideo = true;
  }

  abrirLinkExterno(url?: string, event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    const finalUrl = this.formatExternalUrl(url);
    if (finalUrl) {
      window.open(finalUrl, '_blank', 'noopener,noreferrer');
    }
  }

  descarregarFicheiro(url?: string, nomePadrao: string = 'ficheiro', event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (!url) return;
    const link = document.createElement('a');
    link.href = url;
    link.download = nomePadrao;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  abrirNovaAba(url?: string, event?: Event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  abrirImagem() {
    this.showImage = true;
  }

  abrirDoc() {
    this.ShowDoc = true;
  }

  closeDoc() {
    if (this.docRawUrl) {
      URL.revokeObjectURL(this.docRawUrl);
      this.docRawUrl = undefined;
    }
    this.docPreview = null as any;
  }

  abrirModalMidia(campanhaId = this.campanhaID): void {
    const ref = this.dialogService.open(CampanhaMidiaDialogComponent, {
      header: 'Adicionar Mídia a campanha',
      width: '600px',
      modal: true,
      data: {
        campanhaId,
      },
    });

    ref.onClose.subscribe((formData: FormData) => {
      if (!formData) {
        return;
      }

      this.campanhaService.carregarAnexoBackOffice(formData).subscribe({
        next: (res: any) => {
          this.loadingMidea = true;
          if (res.retorno.codigo === 200) {
            this.messageService.add({
              severity: 'success',
              summary: 'Sucesso',
              detail: res.retorno.mensagem || 'Mídia adicionada com sucesso.',
            });
            this.loadingMidea = false;
            this.getCampanhaByID(this.campanhaID || '');
          } else {
            this.loadingMidea = false;
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: res.retorno.mensagem,
            });
          }
        },
        error: (err) => {
          this.loadingMidea = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Erro',
            detail: getResponseMessage(err, 'Ocorreu um erro ao adicionar a mídia'),
            life: 5000,
          });
          console.error(err);
        },
      });
    });
  }

  ngOnDestroy(): void {
    this.stopYTProgressTimer();
    if (this.overlayTimeout) {
      clearTimeout(this.overlayTimeout);
    }
  }

  private initYoutubePlayer() {
    if (typeof window === 'undefined') return;

    if (!(window as any).YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);

      (window as any).onYouTubeIframeAPIReady = () => {
        this.createYTPlayer();
      };
    } else {
      this.createYTPlayer();
    }
  }

  private createYTPlayer() {
    if (typeof window === 'undefined' || !(window as any).YT) return;

    if (this.ytPlayer) {
      try {
        this.ytPlayer.destroy();
      } catch (e) {}
    }

    this.ytPlayer = new (window as any).YT.Player('yt-player', {
      events: {
        onReady: () => {
          this.duration = this.ytPlayer.getDuration();
          this.isPlaying = true;
          this.startYTProgressTimer();
          this.applyVolumeSettings();
        },
        onStateChange: (event: any) => {
          this.ngZone.run(() => {
            const playerState = event.data;
            if (playerState === (window as any).YT.PlayerState.PLAYING) {
              this.isPlaying = true;
              this.startYTProgressTimer();
            } else if (playerState === (window as any).YT.PlayerState.PAUSED) {
              this.isPlaying = false;
              this.stopYTProgressTimer();
            } else if (playerState === (window as any).YT.PlayerState.ENDED) {
              this.isPlaying = false;
              this.stopYTProgressTimer();
              this.currentTime = 0;
              this.progressPercent = 0;
            }
          });
        },
      },
    });
  }

  private startYTProgressTimer() {
    this.stopYTProgressTimer();
    this.ytInterval = setInterval(() => {
      if (this.ytPlayer && typeof this.ytPlayer.getCurrentTime === 'function') {
        this.ngZone.run(() => {
          this.currentTime = this.ytPlayer.getCurrentTime();
          this.duration = this.ytPlayer.getDuration() || 0;
          this.progressPercent =
            this.duration > 0 ? (this.currentTime / this.duration) * 100 : 0;
        });
      }
    }, 250);
  }

  private stopYTProgressTimer() {
    if (this.ytInterval) {
      clearInterval(this.ytInterval);
      this.ytInterval = null;
    }
  }

  onNativeTimeUpdate() {
    if (this.nativeVideo && this.nativeVideo.nativeElement) {
      const video = this.nativeVideo.nativeElement;
      this.currentTime = video.currentTime;
      this.progressPercent =
        this.duration > 0 ? (this.currentTime / this.duration) * 100 : 0;
    }
  }

  onNativeLoadedMetadata() {
    if (this.nativeVideo && this.nativeVideo.nativeElement) {
      this.duration = this.nativeVideo.nativeElement.duration;
      this.applyVolumeSettings();
    }
  }

  onNativePlayStateChange(playing: boolean) {
    this.isPlaying = playing;
  }

  togglePlay() {
    if (this.vidPreview && this.nativeVideo && this.nativeVideo.nativeElement) {
      const video = this.nativeVideo.nativeElement;
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    } else if (this.linkVideo) {
      if (this.ytPlayer) {
        const state = this.ytPlayer.getPlayerState();
        if (state === (window as any).YT.PlayerState.PLAYING) {
          this.ytPlayer.pauseVideo();
        } else {
          this.ytPlayer.playVideo();
        }
      } else if (this.linkVideo.includes('vimeo.com/')) {
        const iframe = this.youtubePlayerIframe?.nativeElement;
        if (iframe && iframe.contentWindow) {
          this.isPlaying = !this.isPlaying;
          iframe.contentWindow.postMessage(
            JSON.stringify({
              method: this.isPlaying ? 'play' : 'pause',
            }),
            '*',
          );
        }
      }
    }
  }

  toggleMute() {
    this.isMuted = !this.isMuted;
    this.applyVolumeSettings();
  }

  onVolumeChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.volume = Number(target.value);
    this.isMuted = this.volume === 0;
    this.applyVolumeSettings();
  }

  applyVolumeSettings() {
    // 1. Native Video
    if (this.vidPreview && this.nativeVideo && this.nativeVideo.nativeElement) {
      const video = this.nativeVideo.nativeElement;
      video.muted = this.isMuted;
      video.volume = this.volume / 100;
    }
    // 2. YouTube
    if (
      this.linkVideo &&
      this.ytPlayer &&
      typeof this.ytPlayer.setVolume === 'function'
    ) {
      if (this.isMuted) {
        this.ytPlayer.mute();
      } else {
        this.ytPlayer.unMute();
        this.ytPlayer.setVolume(this.volume);
      }
    }
    // 3. Vimeo
    if (this.linkVideo && this.linkVideo.includes('vimeo.com/')) {
      const iframe = this.youtubePlayerIframe?.nativeElement;
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          JSON.stringify({
            method: 'setVolume',
            value: this.isMuted ? 0 : this.volume / 100,
          }),
          '*',
        );
        iframe.contentWindow.postMessage(
          JSON.stringify({
            method: 'setMuted',
            value: this.isMuted,
          }),
          '*',
        );
      }
    }
  }

  seekVideo(event: MouseEvent) {
    const container = event.currentTarget as HTMLElement;
    const rect = container.getBoundingClientRect();
    const clickX = event.clientX - rect.left;
    const width = rect.width;
    const clickPercent = Math.max(0, Math.min(1, clickX / width));

    if (this.duration > 0) {
      const newTime = clickPercent * this.duration;
      if (
        this.vidPreview &&
        this.nativeVideo &&
        this.nativeVideo.nativeElement
      ) {
        this.nativeVideo.nativeElement.currentTime = newTime;
      } else if (
        this.linkVideo &&
        this.ytPlayer &&
        typeof this.ytPlayer.seekTo === 'function'
      ) {
        this.ytPlayer.seekTo(newTime, true);
        this.currentTime = newTime;
        this.progressPercent = clickPercent * 100;
      }
    }
  }

  formatTime(timeInSeconds: number): string {
    if (isNaN(timeInSeconds)) return '0:00';
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  showOverlay() {
    this.isOverlayVisible = true;
    this.resetOverlayTimeout();
  }

  hideOverlay() {
    if (this.isPlaying) {
      this.isOverlayVisible = false;
    }
  }

  resetOverlayTimeout() {
    this.isOverlayVisible = true;
    if (this.overlayTimeout) {
      clearTimeout(this.overlayTimeout);
    }
    if (this.isPlaying) {
      this.overlayTimeout = setTimeout(() => {
        this.isOverlayVisible = false;
      }, 2500);
    }
  }

  onOverlayClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (
      target.closest('.progress-container') ||
      target.closest('.video-header') ||
      target.closest('.volume-container')
    ) {
      return;
    }
    this.togglePlay();
  }
}
